import { TwoColumnLayout } from 'layouts';
import type { GivingContentObjectDetail } from 'models';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { ChannelsDetailCard } from 'features/channels/components/channels-detail-card';
import type { TransactionResultParams } from 'features/transactions';
import { DescriptionCard, DonateButtons, SharingButtons } from '../components';
import { Donations } from './donations';
import { FinishedAlertCard } from './finished-alert-card';
import { GivingDetailsCard } from './giving-details-card';
import { ProgressCard } from './progress-card';
import { Testimonials } from './testimonials';

type P = {
  giveTransaction: TransactionResultParams;
  givingContentObject: GivingContentObjectDetail;
  paymentRedirectUrl: string;
};

const GivingDetail = ({ giveTransaction, givingContentObject, paymentRedirectUrl }: P) => {
  const { giving, organization } = givingContentObject;

  return (
    <TwoColumnLayout
      left={
        <>
          <DonateButtons giveTransaction={giveTransaction} giving={giving} paymentRedirectUrl={paymentRedirectUrl} />
          <FinishedAlertCard giving={giving} />
          <ProgressCard giving={giving} />
          <DescriptionCard giving={giving} />
          <Testimonials givingId={giving.id} />
        </>
      }
      right={
        <>
          <SharingButtons card giving={giving} />
          <Donations givingId={giving.id} />
          <GivingDetailsCard givingContentObject={givingContentObject} />
          <ChannelsDetailCard
            channelAppearance={{
              featured: giving.featuredInChannels,
              visible: giving.showInChannels,
            }}
            channelTags={giving.tags}
            organizationId={organization.id}
          />
        </>
      }
    />
  );
};

export default GivingDetail;
